// Author : Vishnu
// Version :0.0.1
// MODIFIED DATE: 03/09/2025
import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/********************** GET ALL BRANCH LOAN INDEX DETAILS **************************/
export const rangeLoanProposalListFetch = (listData: any) => {
	const data = {
		GetAllBranchLoanIndexDetailsToken: listData,
	};
	const url = `${API_URL}getAllBranchLoanIndexDetailsList`;
	return makeApiCall(url, data);
};
/********************** GET ALL BRANCH LOAN INDEX DETAILS **************************/

/********************** GET MEMBER DETAILS FOR CENTER LOAN START **************************/
export const rangeLoanCenterMemberListFetch = (listData: any) => {
	const data = {
		GetMemberDetailsForCenterLoanToken: listData,
	};
	const url = `${API_URL}getMemberDetailsForCenterLoan`;
	return makeApiCall(url, data);
};
/********************** GET MEMBER DETAILS FOR CENTER LOAN END **************************/

/*************** START GET ALL RANGE PRODUCT  ******************/
export const rangeLoanProductListFetch = (listData: any) => {
	const data = {
		GetRangeLoanRangeProductListToken: listData,
	};
	const url = `${API_URL}getAllRangeProductList`;
	return makeApiCall(url, data);
};
/*************** END GET ALL RANGE PRODUCT  ******************/

/********************** ADD RANGE LOAN PROPOSAL START **************************/
export const rangeLoanProposalAddAPI = (listData: any) => {
	const data = {
		AddRangeLoanProposaltToken: listData,
	};
	const url = `${API_URL}addRangeLoanProposal`;
	return makeApiCall(url, data);
};
/********************** ADD RANGE LOAN PROPOSAL END **************************/

/********************** GET PARTICULAR BRANCH LOAN INDEX INFO START **************************/
export const rangeLoanIndexDetailsFetch = (listData: any) => {
	const data = {
		GetParticularRangeLoanIndexToken: listData,
	};
	const url = `${API_URL}getParticularBranchLoanIndexInfo`;
	return makeApiCall(url, data);
};
/********************** GET PARTICULAR BRANCH LOAN INDEX INFO END **************************/

/********************** UPDATE RANGE LOAN PROPOSAL START **************************/
export const rangeLoanProposalUpdateAPI = (listData: any) => {
	const data = {
		UpdateRangeLoanProposalToken: listData,
	};
	const url = `${API_URL}updateRangeLoanProposal`;
	return makeApiCall(url, data);
};
/********************** UPDATE RANGE LOAN PROPOSAL END **************************/

/********************** GET MEMBER LEAD LIST START **************************/
export const rangeLoanCenterMemberLeadListFetch = (listData: any) => {
	const data = {
		GetMemberLeadListToken: listData,
	};
	const url = `${API_URL}getMemberLeadList`;
	return makeApiCall(url, data);
};
/********************** GET MEMBER LEAD LIST END **************************/

/*************** START APPROVE RANGE LOAN PROPOSAL  ******************/
export const rangeLoanIndexDetailsApproval = (listData: any) => {
	const data = {
		ApproveRangeLoanIndexToken: listData,
	};
	const url = `${API_URL}approveRangeLoanIndex`;
	return makeApiCall(url, data);
};
/*************** END APPROVE RANGE LOAN PROPOSAL  ******************/

/*************** START REVERT APPROVED RANGE LOAN PROPOSAL  ******************/
export const rangeLoanIndexDetailsApprovalRevert = (listData: any) => {
	const data = {
		RevertApprovedRangeLoanIndexToken: listData,
	};
	const url = `${API_URL}revertApprovedRangeLoanIndex`;
	return makeApiCall(url, data);
};
/*************** END REVERT APPROVED RANGE LOAN PROPOSAL  ******************/

/********************** RANGE LOAN PROPOSAL CENTER LIST FETCH START **************************/
export const rangeLoanProposalCenterListFetch = (listData: any) => {
	const data = {
		GetRangeLoanCenterListToken: listData,
	};
	const url = `${API_URL}getAllLocationListBasedLevelToken`;
	return makeApiCall(url, data);
};
/********************** RANGE LOAN PROPOSAL CENTER LIST FETCH END **************************/

/*************** RANGE LOAN INDEX DETAILS REJECT START ******************/
export const rangeLoanIndexDetailsReject = (listData: any) => {
	const data = {
		RejectRangeLoanIndexToken: listData,
	};
	const url = `${API_URL}RejectRangeLoanIndex`;
	return makeApiCall(url, data);
};
/*************** RANGE LOAN INDEX DETAILS REJECT END ******************/
